export const env = (envVar, defaultValue = "") => {
  if (process.env[envVar]) return process.env[envVar];
  return defaultValue;
};
